import Entity from "./entity";
export default class Membership extends Entity<number> {
// images: Array<any>;
  name: string;
  flow: string;
  displayOrder: number;
  showOnHome: boolean;
  price: number;//球会牌价,万元
  description: string;
  courtId:number;
  membershipImages:Array<any>;
  transferFee:number;
  monthlyFee:number;
  position:string;
  linkMan:string;
  phoneNumber:string;
  showPrice:number;
  

}
